export default __webpack_public_path__ + "static/media/deauville05.65ee059c.jpg";